import { ArrowDown2 } from "iconsax-react";
import { BaseButton } from "./BaseButton";
import { useState, useRef, useEffect } from "react";

interface DropdownOption {
  label: string;
  value: string;
}

interface DropdownButtonProps {
  label: string;
  options?: DropdownOption[];
  onSelect?: (value: string) => void;
  variant?: "primary" | "secondary" | "ghost";
}

export const DropdownButton = ({
  label,
  options = [],
  onSelect,
  variant = "secondary",
}: DropdownButtonProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSelect = (value: string) => {
    onSelect?.(value);
    setIsOpen(false);
  };

  return (
    <div className="relative" ref={dropdownRef}>
      <BaseButton onClick={() => setIsOpen(!isOpen)} variant={variant}>
        {label}
        <ArrowDown2 size={16} color="#FEFEFE" />
      </BaseButton>

      {isOpen && options.length > 0 && (
        <div className="absolute top-full left-0 mt-1 bg-dark-10 border border-dark-30 rounded-[5px] shadow-lg z-10 min-w-[150px]">
          {options.map((option) => (
            <button
              key={option.value}
              onClick={() => handleSelect(option.value)}
              className="w-full text-left px-4 py-2 text-sm text-dark-text hover:bg-dark-20 first:rounded-t-[5px] last:rounded-b-[5px]"
            >
              {option.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
